setUserAccountBillingSubscriptionsProcessing